import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Divider, TextField } from '@mui/material';

import { FormConsumer, FormProvider } from '../../../../../components/HO/Form';
import TranslationsContext from '../../../../../components/Container/Language/TranslationsContext';
import configs from '../../../../../configs';

const ManagerUserCreateForm = ({
  formErrors,
  formData,
  formLoading,
  sendForm,
}) => {
  const navigate = useNavigate();
  const { t } = useContext(TranslationsContext);

  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [company, setCompany] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (formErrors) {
      //
    } else if (formData) {
      navigate(`${configs.prefix || ''}/manage/user/user_id/${formData.data.id}/`);
    }
  }, [formErrors, formData, navigate]);

  const phoneProps = {
    label: t('app:controller:customer:table:login'),
    fullWidth: true,
    value: phone,
    onChange: (event) => setPhone(event.target.value),
    sx: {
      '& .MuiOutlinedInput-root': {
        bgcolor: 'background.paper',
      },
      mt: 2,
    },
    error: !!(formErrors && formErrors.phone),
    helperText: formErrors && formErrors.phone ? t(`app:controller:customer:create:error:phone-${formErrors.phone}`) : null,
  };
  const nameProps = {
    label: t('app:controller:customer:details:name'),
    fullWidth: true,
    value: name,
    onChange: (event) => setName(event.target.value),
    sx: {
      '& .MuiOutlinedInput-root': {
        bgcolor: 'background.paper',
      },
      mt: 2,
    },
    error: !!(formErrors && formErrors.name),
    helperText: formErrors && formErrors.name ? t(`app:controller:customer:create:error:phone-${formErrors.name}`) : null,
  };
  const emailProps = {
    label: 'Email',
    fullWidth: true,
    value: email,
    onChange: (event) => setEmail(event.target.value),
    sx: {
      '& .MuiOutlinedInput-root': {
        bgcolor: 'background.paper',
      },
      mt: 2,
    },
    error: !!(formErrors && formErrors.email),
    helperText: formErrors && formErrors.email ? (t(`app:controller:customer:create:error:email-${formErrors.email}`)).replace('{{email}}', formData?.email || '') : null,
  };
  const companyProps = {
    label: t('app:controller:customer:details:company'),
    fullWidth: true,
    value: company,
    onChange: (event) => setCompany(event.target.value),
    sx: {
      '& .MuiOutlinedInput-root': {
        bgcolor: 'background.paper',
      },
      mt: 2,
    },
    error: !!(formErrors && formErrors.company),
    helperText: formErrors && formErrors.company ? t(`app:controller:customer:create:error:phone-${formErrors.company}`) : null,
  };
  const passwordProps = {
    label: t('app:controller:customer:details:password'),
    fullWidth: true,
    value: password,
    onChange: (event) => setPassword(event.target.value),
    sx: {
      '& .MuiOutlinedInput-root': {
        bgcolor: 'background.paper',
      },
      mt: 2,
    },
    error: !!(formErrors && formErrors.password),
    helperText: formErrors && formErrors.password ? t(`app:controller:customer:create:error:password-${formErrors.password}`) : null,
  };
  const dividerProps = {
    sx: {
      mt: 2,
    },
  };
  const buttonProps = {
    variant: 'contained',
    disabled: formLoading,
    onClick: () => sendForm({
      phone,
      name,
      email,
      company,
      password,
    }),
    sx: {
      mt: 2,
    },
    size: 'large',
  };

  return (
    <>
      <TextField {...phoneProps} />
      <TextField {...nameProps} />
      <TextField {...emailProps} />
      <TextField {...companyProps} />
      <TextField {...passwordProps} />
      <Divider {...dividerProps} />
      <Button {...buttonProps}>{t('app:common:execute')}</Button>
    </>
  );
};

const ManagerUserCreateFormContext = (props) => (
  <FormProvider formName="managerUserCreate">
    <FormConsumer>
      {(value) => (<ManagerUserCreateForm {...props} {...value} />)}
    </FormConsumer>
  </FormProvider>
);

export default ManagerUserCreateFormContext;
